import workspace from "../core/workspace";

const sqftSeamShapesManager = {

  findRootShape(shape) {
    let current = shape;
    while (true) {
      const parentId = current.shapeSlab.getParentId();
      if (!parentId) break;

      const parent = workspace.getShapeById(parentId);
      if (!parent) break;

      current = parent;
    }
    return current;
  },

  traverseShapeTree(shape, callback, visited = new Set()) {
    if (!shape || visited.has(shape.id)) return;
      visited.add(shape.id);

      callback(shape);

      const childIds = shape.shapePieces || [];
      for (const childId of childIds) {
        const child = workspace.getShapeById(childId);
        sqftSeamShapesManager.traverseShapeTree(child, callback, visited);
      }
  },

  syncFeatureToSeamedShapes(startShape, featureId) {
    const rootShape = sqftSeamShapesManager.findRootShape(startShape);
    sqftSeamShapesManager.traverseShapeTree(rootShape, (shape) => {
      shape.setFeatureId(featureId);
    });
  }
};

export default sqftSeamShapesManager
